import { render, staticRenderFns } from "./NotificationConfigs.vue?vue&type=template&id=495d82d6&"
import script from "./NotificationConfigs.vue?vue&type=script&lang=js&"
export * from "./NotificationConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports